module.exports = __webpack_public_path__ + "img/badge.b73ced75.jpg";